module.exports = __webpack_public_path__ + "img/settings--active.70c43fdc.svg";